module.exports = __webpack_public_path__ + "static/media/create-shifts.45260e6b.svg";